<div class="dialog-container">
  <div class="header">
    <h2>{{ "app.shopifyOrders.details.options.HoldAtLocationTitle" | translate }}</h2>
    &nbsp;({{ LocationCount }})
  </div>

  <!-- Show this when no locations -->
  @if (LocationCount === 0) {
    <div class="no-locations-container">
      <h1>
        There were no locations found for the consignee address.<br />
        Please unselect "Hold At Location" in the Options section.<br /><br />
        Aucune succursale n'a été trouvée pour l'adresse du destinataire.<br />
        Veuillez désélectionner « Retenir au dépôt » dans la section Options.
      </h1>
    </div>
  }

  <!-- Existing table and footer only if there are locations -->
  @if (LocationCount > 0) {
    <div class="table-container">
      <table mat-table [dataSource]="data.Locations" class="location-table">
        <!-- Select -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let loc" class="select-cell">
            <button mat-raised-button color="primary" (click)="selectLocation(loc)">SELECT</button>
          </td>
        </ng-container>
        <!-- Address -->
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Address</th>
          <td mat-cell *matCellDef="let loc" class="address-cell">
            <div class="company">
              <b>{{ loc.CompanyName }}</b>
            </div>
            <div>{{ loc.StreetLine }}</div>
            <div>{{ formatAddress(loc) }}</div>
          </td>
        </ng-container>
        <!-- Distance -->
        <ng-container matColumnDef="distance">
          <th mat-header-cell *matHeaderCellDef>Distance</th>
          <td mat-cell *matCellDef="let loc">{{ formatDistance(loc) }}</td>
        </ng-container>
        <!-- SpecialInstruction -->
        <ng-container matColumnDef="specialInstruction">
          <th mat-header-cell *matHeaderCellDef>Special Instruction</th>
          <td mat-cell *matCellDef="let loc" class="instruction-cell">
            {{ loc.SpecialInstruction }}
          </td>
        </ng-container>
        <!-- OpenHours -->
        <ng-container matColumnDef="openHours">
          <th mat-header-cell *matHeaderCellDef>Open Hours</th>
          <td mat-cell *matCellDef="let loc" class="hours-cell">
            <table class="hours-table">
              @for (hour of loc.OpenHours; track hour) {
                <tr>
                  <td class="day">{{ hour.DayOfWeek.toUpperCase() }}</td>
                  <td class="time">{{ hour.Begin }}</td>
                  <td class="separator">–</td>
                  <td class="time">{{ hour.End }}</td>
                </tr>
              }
            </table>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="data-row"></tr>
      </table>
    </div>
  }

  <mat-divider></mat-divider>

  @if (LocationCount > 0) {
    <div class="footer">
      @if (data.Messages?.length) {
        <div class="messages">
          @for (msg of data.Messages; track msg) {
            <div>{{ msg }}</div>
          }
        </div>
      }
    </div>
  }

  <div class="actions">
    <button mat-raised-button color="warn" class="cancel-btn" (click)="cancel()">CANCEL</button>
  </div>
</div>
